var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpDownCaret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46854 8.06177H1.53146C1.2934 8.06177 1.16047 7.81041 1.3079 7.63881L5.27644 3.03705C5.39003 2.90533 5.60876 2.90533 5.72356 3.03705L9.6921 7.63881C9.83953 7.81041 9.7066 8.06177 9.46854 8.06177Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6921 11.3612L5.72356 15.963C5.60997 16.0947 5.39124 16.0947 5.27644 15.963L1.3079 11.3612C1.16047 11.1896 1.2934 10.9383 1.53146 10.9383H9.46854C9.7066 10.9383 9.83953 11.1896 9.6921 11.3612Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownCaret);
export default __webpack_public_path__ + "static/media/up-down-caret.14f76872c5a879225cdd94e4b8a0abac.svg";
export { ForwardRef as ReactComponent };